import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { withTranslation } from 'react-i18next';
import { DropdownButton, MenuItem } from 'react-bootstrap';

const NewEnrolmentButton = ({ t, id, date, enableMakeUps, onNewClick, onNewMakeupClick, className, style }) => {

	return <div className={className} style={style}><DropdownButton id={id || 'NewEnrolmentButton'} title={<span>{t('Common_New')} <FontAwesomeIcon icon={faAngleDown} /></span>} noCaret bsStyle='primary'>
		<MenuItem key='pending-approval' onSelect={() => onNewClick(date)}>
			{t('LessonAttendance_NewPendingApproval')}
		</MenuItem>
		{enableMakeUps && <MenuItem key='makeup' onSelect={() => onNewMakeupClick(date)}>
			{t('LessonAttendance_NewMakeup')}
		</MenuItem>}
	</DropdownButton></div>;
};

export default withTranslation()(NewEnrolmentButton);